import React from 'react';

export default function NoData() {
  return <div style={{ minHeight: '75%', color: '#C4C4C4', fontSize: '20px', marginTop:'10%', marginBottom:'10%' }}
    className='d-flex justify-content-center align-items-center'>
    No profiles to display
  </div>;
}
